<template>
  <h3
    class="content-header"
    v-bind:class="[
      fontColor ? 'font-' + fontColor : '',
      borderColor ? 'border-' + borderColor : '',
    ]"
  >
    <div v-if="headingTitle && !smallTitle" class="title-group">
      <span
        class="heading-title"
        v-bind:style="{
          width: headingTitleWidth + 'px',
          borderRadius: headingTitleRadius + 'px',
        }"
      >
        {{ headingTitle }}
      </span>
      <span class="title"> {{ title }} </span>
    </div>
    <div v-else-if="headingTitle && smallTitle" class="title-group">
      <span
        class="heading-title"
        v-bind:style="{
          width: headingTitleWidth + 'px',
          borderRadius: headingTitleRadius + 'px',
          verticalAlign: 'bottom',
        }"
      >
        {{ headingTitle }}
      </span>
      <span v-if="!smallTitle" class="title"> {{ title }} </span>
      <div
        v-else
        style="display: inline-block; line-height: 22px; vertical-align: bottom; margin-left: 5px;"
      >
        <span class="smallTitle" style="font-size: 14px;">
          {{ smallTitle }}
        </span>
        <br />
        <span class="title" style="padding-left: 0; font-size: 20px;">
          {{ title }}
        </span>
      </div>
    </div>
    <div v-else-if="!headingTitle && withBorder" class="title-group with-boder">
      <span class="title"> {{ title }} </span>
    </div>
    <div v-else class="title-group">
      <span class="title"> ■ {{ title }} </span>
    </div>
    <div v-if="!withoutUnderline" class="content-border"></div>
  </h3>
</template>

<script>
export default {
  props: [
    'headingTitle',
    'headingTitleWidth',
    'headingTitleRadius',
    'smallTitle',
    'title',
    'withBorder',
    'fontColor',
    'borderColor',
    'withoutUnderline',
  ],
}
</script>

<style scoped>
.content-header {
  margin: 10px 0;
}

.content-header .title-group {
  font-weight: bold;
}

.content-header .title-group .heading-title {
  display: inline-block;

  padding: 3px 15px;

  color: white;
  border-radius: 4px;
  background-color: rgb(26, 87, 167);
}

.content-header .title-group .title {
  padding-left: 15px;

  color: rgb(26, 87, 167);
}

.content-header .with-boder {
  border-left: 4px solid rgb(80, 172, 252);
}

.content-header .content-border {
  margin: 5px 0;

  border-bottom: 1px solid rgb(26, 87, 167);
}

.content-header.border-green .title-group .heading-title {
  background-color: rgb(44, 179, 66);
}

.content-header.font-black .title-group .title {
  color: #4d4d4d;
}

.content-header.border-green .with-boder {
  border-left: 4px solid rgb(73, 195, 108);
}

.content-header.border-green .content-border {
  border-bottom: 1px solid rgb(108, 207, 136);
}

.content-header.border-blue .title-group .heading-title {
  background-color: rgb(16, 106, 203);
}

.content-header.border-blue .with-boder {
  border-left: 4px solid rgb(16, 106, 203);
}

.content-header.border-blue .content-border {
  border-bottom: 1px solid rgb(16, 106, 203);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ContentHeader.vue